const UUID_SEPARATOR_REGEXP = /-/g;
let fallbackSequence = 0;

function getWebCrypto() {
  if (typeof globalThis !== 'undefined' && globalThis.crypto) {
    return globalThis.crypto;
  }

  if (typeof window !== 'undefined') {
    return window.crypto || window.msCrypto;
  }

  return undefined;
}

function toFixedHex(value, length) {
  const hex = value.toString(16);
  if (hex.length >= length) {
    return hex.slice(-length);
  }
  return new Array(length - hex.length + 1).join('0') + hex;
}

function getRandomHex(length) {
  let value = '';
  while (value.length < length) {
    value += toFixedHex(Math.floor(Math.random() * 0x100000000), 8);
  }
  return value.slice(0, length);
}

function generateFallbackTraceId() {
  const timestamp = typeof Date.now === 'function' ? Date.now() : new Date().getTime();
  fallbackSequence = (fallbackSequence + 1) % 0x10000;

  return (
    toFixedHex(timestamp, 12) +
    toFixedHex(fallbackSequence, 4) +
    getRandomHex(16)
  );
}

export function generateQrcodeTraceId() {
  const webCrypto = getWebCrypto();

  try {
    if (webCrypto && typeof webCrypto.randomUUID === 'function') {
      return webCrypto.randomUUID().replace(UUID_SEPARATOR_REGEXP, '').toLowerCase();
    }

    if (webCrypto && typeof webCrypto.getRandomValues === 'function') {
      const bytes = webCrypto.getRandomValues(new Uint8Array(16));
      bytes[6] = (bytes[6] & 0x0f) | 0x40;
      bytes[8] = (bytes[8] & 0x3f) | 0x80;

      let value = '';
      for (let index = 0; index < bytes.length; index += 1) {
        value += toFixedHex(bytes[index], 2);
      }
      return value;
    }
  } catch (error) {
    // Web Crypto 不可用或调用异常时，使用追踪 ID 的兼容兜底方案。
  }

  return generateFallbackTraceId();
}
